// @flow

import gql from 'graphql-tag';

import { teamMemberFragment } from './fragments';

export const teamMemberQuery = gql`
  ${teamMemberFragment}

  query TeamMembers($accountId: Int!, $limit: Int, $offset: Int, $teamId: ID!) {
    account(id: $accountId) {
      team(id: $teamId) {
        members(limit: $limit, offset: $offset) {
          edges {
            ...teamMember
          }
          totalCount
        }
      }
    }
  }
`;

export const searchMembersQuery = gql`
  ${teamMemberFragment}

  query SearchMember($accountId: Int!, $search: String) {
    searchMembers(accountId: $accountId, search: $search) {
      edges {
        ...teamMember
      }
    }
  }
`;
